import { paginate } from '../plugins';
import PluggableModule from '../pluggable';

const conceptAttempts = new PluggableModule('conceptAttempt');

conceptAttempts.extend({
  namespaced: true
});

// TODO: If we start having more than 50 attempts pre day. we should start
// supporting filtering disabling pagination in paginate plugin and use that.
export default paginate('conceptAttempts', {
  filterDefinition: {
    concept: 'reference',
    user: 'reference',
    tags: 'array-contains-any',
    createdAt: ['>=', '<=']
  },
  pageSize: 50
})(conceptAttempts);
